import { gql } from '@apollo/client'

import { eventEditFragment } from './fragments/EventEdit.fragment'

export const GET_EVENT = gql`
    query EditEvent($guid: String!) {
        entity(guid: $guid) {
            guid
            ...EventEdit
        }
    }
    ${eventEditFragment}
`
